import React from "react";
import LegalLayout from "./LegalLayout";

export default function Terms() {
    return (
        <LegalLayout title="Terms of Service" lastUpdated="February 17, 2026" path="/terms">
            <p>
                These Terms of Service ("<strong>Terms</strong>") govern your use of
                KickLoom (the "Service"). By creating an account or otherwise
                accessing the Service, you agree to be bound by these Terms. If you
                do not agree, do not use KickLoom.
            </p>

            <h2>1. Eligibility</h2>
            <p>
                You must be at least 18 years old (or the legal age of majority in
                your jurisdiction, whichever is higher) to use KickLoom. By
                registering, you confirm that you meet this requirement and that
                participating in sports-related staking or wagering is lawful in
                your jurisdiction.
            </p>

            <h2>2. Nature of the service</h2>
            <p>
                KickLoom provides AI-generated football match predictions, live
                scores, and statistical information for entertainment and
                informational purposes only. Our picks are based on probabilistic
                modelling and historical data; they are not guaranteed outcomes.
                <strong> We are not a bookmaker.</strong> We do not accept stakes,
                hold customer funds, or pay out winnings. Any betting you choose to
                do is between you and a regulated bookmaker of your choice.
            </p>

            <h2>3. Account</h2>
            <ul>
                <li>You are responsible for keeping your password confidential.</li>
                <li>You are responsible for all activity that occurs under your account.</li>
                <li>You must provide accurate registration information and update it as necessary.</li>
                <li>One person, one account. We may suspend duplicate or fraudulent accounts.</li>
            </ul>

            <h2>4. Subscriptions and payments</h2>
            <p>
                KickLoom offers a free Basic tier and a paid VIP tier billed monthly
                via Paystack. By subscribing to VIP, you authorise us (through
                Paystack) to charge your chosen payment method on a recurring monthly
                basis until you cancel. You can cancel at any time from your
                Settings; cancellation stops the next billing cycle but does not
                refund the current period.
            </p>

            <h2>5. Refunds</h2>
            <p>
                Because the VIP subscription provides immediate access to digital
                content, all payments are <strong>non-refundable</strong> except
                where required by law. If you believe you were charged in error,
                contact us within 7 days of the charge.
            </p>

            <h2>6. Acceptable use</h2>
            <ul>
                <li>Do not scrape, reverse-engineer or republish our predictions or odds without permission.</li>
                <li>Do not use the Service to facilitate or solicit illegal activity.</li>
                <li>Do not attempt to disrupt, probe, or attack our infrastructure.</li>
                <li>Do not share your VIP credentials with others; we may revoke access without refund if we detect sharing.</li>
            </ul>

            <h2>7. Intellectual property</h2>
            <p>
                All content on KickLoom — code, design, prediction text, brand —
                belongs to KickLoom or its licensors. You may not copy or
                redistribute it. The names of teams, leagues and bookmakers belong
                to their respective owners and are used here for descriptive
                purposes only.
            </p>

            <h2>8. Disclaimers</h2>
            <p>
                The Service is provided <strong>"as is" and "as available"</strong>.
                We make no warranty that our predictions will be accurate, that the
                Service will be uninterrupted, or that any pick will produce a
                positive return. Sports outcomes are inherently uncertain.
            </p>

            <h2>9. Limitation of liability</h2>
            <p>
                To the maximum extent permitted by law, KickLoom is not liable for
                any indirect, incidental or consequential damages — including loss
                of stakes, loss of profits, or losses arising from third-party
                bookmakers — that result from your use of the Service. Our total
                aggregate liability to you shall not exceed the amount you paid
                KickLoom in the 12 months preceding the claim.
            </p>

            <h2>10. Termination</h2>
            <p>
                You may close your account at any time. We may suspend or terminate
                accounts that violate these Terms, with or without notice.
            </p>

            <h2>11. Changes</h2>
            <p>
                We may update these Terms from time to time. We'll post material
                changes on this page and, where appropriate, notify you by email.
                Continued use after changes constitutes acceptance.
            </p>

            <h2>12. Contact</h2>
            <p>
                Questions about these Terms can be sent to{" "}
                <a className="text-primary underline" href="mailto:support@kickloom.com">
                    support@kickloom.com
                </a>
                .
            </p>
        </LegalLayout>
    );
}
